import { Mail, MailOpen, MousePointerClick } from "lucide-react";
import { KpiTile } from "./KpiTile";
import type { NotificationEngagementSummary } from "@colab/shared";

function formatRate(rate: number | null): string {
  if (rate === null) return "—";
  return `${(rate * 100).toFixed(0)}%`;
}

export function NotificationEngagementCard({
  summary,
}: {
  summary: NotificationEngagementSummary;
}) {
  const { totals, openRate, clickRate } = summary;

  return (
    <section className="rounded-xl border bg-card p-5">
      <header className="mb-4">
        <h2 className="font-display text-base font-semibold tracking-tight">
          Notifications
        </h2>
        <p className="mt-0.5 text-xs text-muted-foreground">
          Emails sent, opened, and clicked for this partner. Anonymous form
          submissions are excluded.
        </p>
      </header>

      <div className="grid grid-cols-3 gap-3">
        <KpiTile
          label="Sent"
          value={totals.sent.current.toLocaleString()}
          delta={totals.sent}
          icon={Mail}
          className="p-3"
        />
        <KpiTile
          label="Opened"
          value={totals.opened.current.toLocaleString()}
          delta={totals.opened}
          icon={MailOpen}
          hint={`Open rate ${formatRate(openRate)}`}
          className="p-3"
        />
        <KpiTile
          label="Clicked"
          value={totals.clicked.current.toLocaleString()}
          delta={totals.clicked}
          icon={MousePointerClick}
          hint={`Click rate ${formatRate(clickRate)}`}
          className="p-3"
        />
      </div>
    </section>
  );
}
